import React from 'react';
import CampaignContactsDataRows from './CampaignContactsDataRows';

const CampaignContactsTable = ({ campaign, readOnly, onEdit, onDeleteClick, ...props }) => {
    const headHeight = 30;
    const visibleActiveRows = 5;
    const rowHeight = 30;
    const totalHeight = rowHeight * visibleActiveRows + headHeight;

    /**
     * Generates the gridTemplateAreas css to fit the data
     */
    const generateGridTemplateAreas = () => {
        // active grid headers
        let retVal = `'actionH actionH nameH accountH emailH mobileH roleH gutterH'`;
        // active grid data
        for (let i = 0; i < campaign?.campaignContacts?.length || i < visibleActiveRows; i++) {
            retVal = `
                ${retVal}
                'i${i} ii${i} name${i} account${i} email${i} mobile${i} role${i} ${
    i < visibleActiveRows ? 'gutter' : '.'
}'
            `;
        }

        return retVal;
    };

    const handleDeleteClick = (entity) => {
        const contacts = [...campaign.campaignContacts];
        const index = contacts.indexOf(entity);
        if (index > -1) {
            contacts.splice(index, 1);
        }

        onDeleteClick(contacts);
    };

    return (
        <div {...props}>
            <div
                style={{
                    display: 'grid',
                    boxSizing: 'border-box',
                    gridTemplateColumns: '40px 40px 1fr 1fr 1fr 1fr 1fr 19px',
                    gridTemplateAreas: generateGridTemplateAreas(),
                    backgroundColor: '#ffffff',
                    overflowY: 'hidden',
                    height: totalHeight
                }}
            >
                <CampaignContactsDataRows
                    data={campaign?.campaignContacts}
                    rowHeight={rowHeight}
                    visibleRows={visibleActiveRows}
                    readOnly={readOnly}
                    onEdit={onEdit}
                    onDeleteClick={handleDeleteClick}
                />
            </div>
        </div>
    );
};

export default CampaignContactsTable;
